import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, FormGroup, Input, Label, Modal, ModalBody, Row } from "reactstrap";

export const DiscountSaleCalculator = ({ originalAmount, discount = 0, setDiscount, discountSaleCalculatorOpen, setDiscountSaleCalculatorOpen }) => {

  const [ calculatedDiscount, setCalculatedDiscount ] = useState(discount);
  const [ _requiredAmount, _setRequiredAmount ] = useState(originalAmount - (originalAmount * (discount)/100));

  function handleSubmit () {
    setDiscount(calculatedDiscount);
    setDiscountSaleCalculatorOpen(false);
  };

  const toggle = () => {
    setDiscountSaleCalculatorOpen(!discountSaleCalculatorOpen);
  };

  //calculate the new discount based on the required amount
  const calculateDiscount = (requiredAmountValue) => {
    // Ensure the requiredAmount does not exceed the total amount
    console.log("trigerd",{requiredAmountValue})
    if (requiredAmountValue > originalAmount) {
      requiredAmountValue = originalAmount;
    }
    if (requiredAmountValue < 0) {
      requiredAmountValue = 0;
    }

    // Calculate the discount needed to achieve the requiredAmount
    let _calculatedDiscount = ((originalAmount - requiredAmountValue) / originalAmount) * 100;
    if (_calculatedDiscount.toString().length > 5) {
      // _calculatedDiscount = _calculatedDiscount.toFixed(2);
    }
    setCalculatedDiscount(_calculatedDiscount);

    _setRequiredAmount(requiredAmountValue);
  };

  useEffect(() => {
    calculateDiscount(_requiredAmount);
  }, []);

  useEffect(() => {
    // Reset state when originalAmount or discount changes
    setCalculatedDiscount(discount);
    _setRequiredAmount(originalAmount - (originalAmount * discount) / 100);
  }, [originalAmount, discount]);

  return (
    <section>
      <Modal
        isOpen={discountSaleCalculatorOpen}
        toggle={toggle}
        centered={true}
        size="m"
        className="large-pop delete-pop"
      >
        <ModalBody>
          <div className="modal-body-content">
            <Formik
              initialValues={{}}
              onSubmit={handleSubmit}
            >
              {({ errors, values, touched, setFieldValue }) => {
                return (
                  <Form className="admin-details">
                    <div className="content">
                      <div className="delete-title">
                        <h2 className="">Discount Calculator</h2>
                      </div>
                      <div className="delete-data">
                        <h4>
                          Calculate your discount percentage based on the final amount
                        </h4>
                      </div>
                      <div className="pb-4">
                        <Row className="justify-content-center">
                          <Col md={9} className="p-3">
                            <FormGroup className="custom-inputs mb-md-0">
                              <Input
                                type="number"
                                name="originalAmount"
                                id="originalAmount"
                                placeholder="Original Amount"
                                value={originalAmount}
                                disabled={true}
                                />
                              <Label for="originalAmount">
                                Original Amount
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col md={9} className="p-3">
                            <FormGroup className="custom-inputs mb-md-0">
                              <Input
                                type="number"
                                name="requiredAmount"
                                id="requiredAmount"
                                placeholder="Required Amount"
                                value={_requiredAmount}
                                // onChange={(e) =>
                                  //   setFieldValue("amount", e.target.value)
                                  // }
                                  onChange={(e) => calculateDiscount(e.target.value)}
                                  required
                              />
                              <Label for="requiredAmount">
                                Required Amount
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col md={9} className="p-3">
                            <FormGroup className="custom-inputs mb-md-0">
                              <Input
                                type="number"
                                name="calculatedDiscount"
                                id="calculatedDiscount"
                                placeholder="Calculated Discount"
                                value={calculatedDiscount}
                                // onChange={(e) =>
                                //   setFieldValue("calculatedDiscount", e.target.value)
                                // }
                                disabled={true}
                              />
                              <Label for="calculatedDiscount">
                                Discount
                              </Label>
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <div className="action-btn-block pt-2">
                      <button
                        className={`btn btn-small btn-transparent`}
                        type="button"
                        onClick={toggle}
                      >
                        {/* {!props.disabled ? props.value : } */}
                        {"Cancel"}
                      </button>
                      <button className={`btn btn-small btn-grey`} type="submit">
                        {"Confirm"}
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </ModalBody>
      </Modal>
    </section>
  );
};
